const initProductSelection = (options = {}) => {
	const config = {
		articleNameSelector: '#article_name',
		articleNoSelector: '#article_no',
		supplierSelector: '#supplier',
		orderSelector: '#order_nr',
		quantitySelector: '#quantity_affected_items',
		...options
	};

	const articleName = $(config.articleNameSelector);
	if(!articleName.length){
		return;
	}

	const articleNo = $(config.articleNoSelector);
	const supplier = $(config.supplierSelector);
	const orderNr = $(config.orderSelector);
	const quantityInput = $(config.quantitySelector);
	const productMetaRaw = articleName.data('product-meta') || articleName.attr('data-product-meta');
	let productMeta = {};
	const productOrdersRaw = articleName.data('product-orders') || articleName.attr('data-product-orders');
	let productOrders = {};
	const orderAmountsRaw = articleName.data('product-order-amounts') || articleName.attr('data-product-order-amounts');
	let orderAmounts = {};

	if(productMetaRaw){
		if(typeof productMetaRaw === 'object'){
			productMeta = productMetaRaw;
		}else{
			try{
				productMeta = JSON.parse(productMetaRaw);
			}catch(error){
				productMeta = {};
			}
		}
	}
	if(productOrdersRaw){
		if(typeof productOrdersRaw === 'object'){
			productOrders = productOrdersRaw;
		}else{
			try{
				productOrders = JSON.parse(productOrdersRaw);
			}catch(error){
				productOrders = {};
			}
		}
	}
	if(orderAmountsRaw){
		if(typeof orderAmountsRaw === 'object'){
			orderAmounts = orderAmountsRaw;
		}else{
			try{
				orderAmounts = JSON.parse(orderAmountsRaw);
			}catch(error){
				orderAmounts = {};
			}
		}
	}

	const getSelectOptions = (select) => {
		if(!select.length){
			return [];
		}

		const cached = select.data('capa-options');
		if(cached){
			return cached;
		}

		const options = select.find('option').map((index, option) => ({
			id: option.value,
			text: $(option).text(),
		})).get();

		select.data('capa-options', options);
		return options;
	};

	const setSelectOptions = (select, options, selectedValue = null) => {
		if(!select.length){
			return;
		}

		const currentValue = selectedValue !== null ? selectedValue : select.val();

		select.empty();
		options.forEach((option) => {
			select.append(new Option(option.text, option.id, false, option.id == currentValue));
		});

		if(currentValue !== null && currentValue !== undefined){
			select.val(currentValue);
		}

		select.trigger('change.select2');
	};

	const filterSelectOptions = (select, allowedValues) => {
		if(!select.length){
			return;
		}

		const fullOptions = getSelectOptions(select);
		const allowedSet = new Set((allowedValues || []).map((value) => value === null || value === undefined ? value : value.toString()));

		const filtered = fullOptions.filter((option) => {
			if(option.id === '' || option.id === null || option.id === undefined){
				return true;
			}
			return allowedSet.has(option.id.toString());
		});

		setSelectOptions(select, filtered);
	};

	const resetSelectOptions = (select) => {
		setSelectOptions(select, getSelectOptions(select));
	};

	const updateQuantityLimit = () => {
		if(!quantityInput.length){
			return;
		}

		const selectedId = articleName.val();
		const selectedOrder = orderNr.val();
		if(!selectedId || !selectedOrder){
			quantityInput.removeAttr('max');
			return;
		}

		const maxValue = orderAmounts[selectedId] ? orderAmounts[selectedId][selectedOrder] : null;
		if(maxValue === null || maxValue === undefined || maxValue === ''){
			quantityInput.removeAttr('max');
			return;
		}

		quantityInput.attr('max', maxValue);
		clampQuantityValue();
	};

	const clampQuantityValue = () => {
		if(!quantityInput.length){
			return;
		}

		const maxValue = quantityInput.attr('max');
		if(!maxValue){
			return;
		}

		const currentValue = quantityInput.val();
		if(currentValue === null || currentValue === undefined || currentValue === ''){
			return;
		}

		const numericValue = parseFloat(currentValue);
		if(Number.isNaN(numericValue)){
			return;
		}

		const numericMax = parseFloat(maxValue);
		if(Number.isNaN(numericMax)){
			return;
		}

		if(numericValue > numericMax){
			quantityInput.val(numericMax);
		}
	};

	const syncProductFields = () => {
		const selectedId = articleName.val();
		if(!selectedId){
			resetSelectOptions(articleNo);
			resetSelectOptions(supplier);
			resetSelectOptions(orderNr);
			if(quantityInput.length){
				quantityInput.removeAttr('max');
			}
			return;
		}

		const meta = productMeta[selectedId];
		const ordersForProduct = productOrders[selectedId] || [];
		if(!meta){
			if(articleNo.length){
				articleNo.val(null).trigger('change');
				resetSelectOptions(articleNo);
			}
			if(supplier.length){
				supplier.val(null).trigger('change');
				resetSelectOptions(supplier);
			}
			resetSelectOptions(orderNr);
			if(quantityInput.length){
				quantityInput.removeAttr('max');
			}
			return;
		}

		if(articleNo.length && meta.code){
			articleNo.val(meta.code).trigger('change');
			filterSelectOptions(articleNo, [meta.code]);
		}
		if(supplier.length && meta.supplier_id){
			supplier.val(meta.supplier_id).trigger('change');
			filterSelectOptions(supplier, [meta.supplier_id]);
		}
		filterSelectOptions(orderNr, ordersForProduct);
		updateQuantityLimit();
	};

	getSelectOptions(articleNo);
	getSelectOptions(supplier);
	getSelectOptions(orderNr);
	articleName.unbind('change.product-selection').bind('change.product-selection', syncProductFields);
	orderNr.unbind('change.product-selection').bind('change.product-selection', updateQuantityLimit);
	if(quantityInput.length){
		quantityInput.unbind('input.product-selection change.product-selection').bind('input.product-selection change.product-selection', clampQuantityValue);
	}
	syncProductFields();
};

const initStepGating = (options = {}) => {
	const config = {
		containerSelector: '[data-step]',
		messageSelector: '.step-message',
		disabledClass: 'step-disabled',
		formSelector: null,
		eventNamespace: 'step-gating',
		...options
	};

	const stepContainers = $(config.containerSelector);
	if(!stepContainers.length){
		return;
	}

	const form = config.formSelector ? $(config.formSelector) : stepContainers.closest('form').first();

	const highlightClass = 'highlight-input';

	const getFormGroupInputs = (group) => group.find('input, select, textarea')
		.filter(':not([type="hidden"])')
		.filter(':not(.select2-search__field)')
		.filter(':not([disabled])')
		.filter(':not([data-step-optional])');

	const getPendingInputs = (group) => {
		if(!group.is(':visible')){
			return $();
		}

		const inputs = getFormGroupInputs(group);
		if(!inputs.length){
			return $();
		}

		const radios = inputs.filter('[type="radio"]');
		if(radios.length){
			return radios.filter(':checked').length > 0 ? $() : radios;
		}

		const checkboxes = inputs.filter('[type="checkbox"]');
		const requiredCheckboxes = checkboxes.filter('[required], [data-required="true"], [data-step-required="true"]');
		if(requiredCheckboxes.length){
			return checkboxes.filter(':checked').length > 0 ? $() : checkboxes;
		}

		let pending = $();
		const inputsToCheck = inputs.filter(':not([type="checkbox"])');
		inputsToCheck.each((index, input) => {
			const field = $(input);
			if(field.is('select')){
				const value = field.val();
				if(field.prop('multiple')){
					if(!value || !value.length){
						pending = pending.add(field);
					}
				}else if(!value){
					pending = pending.add(field);
				}
				return;
			}

			const value = field.val();
			if(value === null || value === undefined || value.toString().trim() === ''){
				pending = pending.add(field);
			}
		});

		return pending;
	};

	const isFormGroupComplete = (group) => getPendingInputs(group).length === 0;

	const toggleFieldHighlight = (field, highlight) => {
		field.toggleClass(highlightClass, highlight);
		if(field.is('select') && field.hasClass('select2-hidden-accessible')){
			field.next('.select2-container').find('.select2-selection').toggleClass(highlightClass, highlight);
		}
	};

	const clearStepHighlights = (stepElement) => {
		stepElement.find(`.${highlightClass}`).removeClass(highlightClass);
	};

	const highlightPendingFields = (stepElement) => {
		clearStepHighlights(stepElement);
		stepElement.find('.form-group').each((index, group) => {
			const pendingFields = getPendingInputs($(group));
			if(!pendingFields.length){
				return;
			}
			pendingFields.each((fieldIndex, field) => {
				toggleFieldHighlight($(field), true);
			});
		});
	};

	const isStepComplete = (step) => {
		let complete = true;
		step.find('.form-group').each((index, group) => {
			const formGroup = $(group);
			if(!isFormGroupComplete(formGroup)){
				complete = false;
				return false;
			}
		});

		return complete;
	};

	const setStepEnabled = (stepElement, enabled) => {
		const inputs = stepElement.find('input, select, textarea, button')
			.filter(':not([type="hidden"])');
		inputs.prop('disabled', !enabled);
		stepElement.find(config.messageSelector).toggleClass('d-none', enabled);
		if(config.disabledClass){
			stepElement.toggleClass(config.disabledClass, !enabled);
		}

		const selects = inputs.filter('select');
		selects.filter('.select2-hidden-accessible').trigger('change.select2');
	};

	const updateStepVisibility = () => {
		let allowNext = true;
		stepContainers.each((index, step) => {
			const stepElement = $(step);

			setStepEnabled(stepElement, allowNext);
			if(allowNext){
				const complete = isStepComplete(stepElement);
				if(complete){
					clearStepHighlights(stepElement);
				}else{
					highlightPendingFields(stepElement);
					allowNext = false;
				}
			}else{
				clearStepHighlights(stepElement);
			}
		});
	};

	const namespace = config.eventNamespace ? '.' + config.eventNamespace : '.step-gating';
	if(form.length){
		form.off(`change${namespace} input${namespace}`, 'input, select, textarea');
		form.on(`change${namespace} input${namespace}`, 'input, select, textarea', updateStepVisibility);
	}

	updateStepVisibility();
};

export { initProductSelection, initStepGating };
